import { render, staticRenderFns } from "./FaqPage.vue?vue&type=template&id=b91a26be&lang=true&"
import script from "./FaqPage.vue?vue&type=script&lang=js&"
export * from "./FaqPage.vue?vue&type=script&lang=js&"
import style0 from "./FaqPage.vue?vue&type=style&index=0&id=b91a26be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports